import { coerceImageSrcForHtml } from '../utils/base64-image';

/** Item de GET /api/Notifications (envelope `data[]` ou array direto). */
export interface NotificationItem {
  id: string;
  title: string;
  message: string;
  createdAt: string;
  isRead: boolean;
  actionUsername: string | null;
  actionUserProfilePicture: string | null;
}

export function normalizeNotification(raw: unknown): NotificationItem | null {
  if (raw == null || typeof raw !== 'object') return null;
  const o = raw as Record<string, unknown>;
  const id = String(
    o['externalId'] ?? o['ExternalId'] ?? o['id'] ?? o['Id'] ?? o['notificationId'] ?? o['NotificationId'] ?? '',
  ).trim();
  if (!id) return null;
  const title =
    String(o['title'] ?? o['Title'] ?? o['subject'] ?? o['Subject'] ?? 'Notificação').trim() ||
    'Notificação';
  const message = String(
    o['message'] ?? o['Message'] ?? o['body'] ?? o['Body'] ?? o['content'] ?? o['Content'] ?? o['description'] ?? '',
  ).trim();
  const createdAt = String(
    o['createdAt'] ?? o['CreatedAt'] ?? o['createdOn'] ?? o['date'] ?? o['Date'] ?? '',
  ).trim();
  const isRead =
    o['isRead'] === true ||
    o['IsRead'] === true ||
    o['read'] === true ||
    o['wasRead'] === true ||
    o['isRead'] === 1 ||
    o['read'] === 1;
  const actionUsername =
    String(o['actionUsername'] ?? o['ActionUsername'] ?? o['senderUsername'] ?? o['triggerUsername'] ?? '').trim() || null;
  /**
   * A API devolve a foto como base64 cru (sem prefixo `data:`), tal como em
   * `normalizeAuthUser` — sem `coerceImageSrcForHtml` o `<img src>` não renderiza.
   */
  const actionUserProfilePicture = coerceImageSrcForHtml(
    String(o['actionUserProfilePicture'] ?? o['ActionUserProfilePicture'] ?? o['senderProfilePicture'] ?? o['triggerUserProfilePicture'] ?? '').trim() || null,
  );
  return { id, title, message, createdAt, isRead, actionUsername, actionUserProfilePicture };
}
